<template>
  <a-popover>
    <template #content>
      <div class="remind_way">
        <!-- <p @click="visible = true">协助上传</p> -->
        <p @click="handleClick">提醒患者</p>
      </div>
    </template>
    <label class="icon-box">
      <auth-img class="icon-img" src="@/assets/img/chat/checkList.png" alt="" />
      <div class="icon-label">检查单</div>
    </label>
  </a-popover>

  <a-modal
    :maskClosable="false"
    v-model:visible="visible"
    centered
    width="616px"
    @cancel="handleCancel"
  >
    <template #title>
      <div class="modal_title">
        <span class="title">检查检验单</span>
        <span class="tips">（支持jpg/png格式，限10M以内，最多上传20张）</span>
      </div>
    </template>
    <template #footer>
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        @click="handleOk"
        :disabled="!fileList.length"
      >
        确定
      </a-button>
    </template>
    <UploadEdit @onSuccess="onSuccess" @updetaList="onSuccess" :fileList="fileList" />
  </a-modal>
</template>

<script setup>
import qs from 'qs'
import axios from 'axios'
import { defineProps, createVNode, ref, computed } from 'vue'
import { message as Message, Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { getToken, TokenKey } from '@/utils/auth'
import UploadEdit from '@/components/UploadEdit'
import { uploadCheckFile } from '@/api/workPlace/checklist'
import { useStore } from 'vuex'

const store = useStore()
const fileList = ref([])
const curGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
const ucPatientId = curGroupInfo.value.patientInfo.ucUserId
const ucDoctorId = curGroupInfo.value.doctorInfo.ucUserId
const ucPatientName = curGroupInfo.value.patientInfo.username
const ucDoctorName = curGroupInfo.value.doctorInfo.username
const serialNumber = curGroupInfo.value.targetWorkOrder.serialNumber
const props = defineProps({
  chatId: {
    type: [String, undefined],
    default: ''
  },
  groupType: {
    type: [Number, String],
    default: 1
  }
})

const visible = ref(false)
const handleClick = () => {
  Modal.confirm({
    title: () => '确定发送检查单吗',
    icon: () => createVNode(ExclamationCircleOutlined),
    cancelText: () => '取消',
    centered: true,
    okText: () => '确定',
    onOk: () => {
      const params = {
        groupId: props.chatId,
        serialNumber,
        ucDoctorId,
        ucDoctorName,
        ucPatientId,
        ucPatientName,
        groupType: props.groupType
      }
      axios({
        method: 'POST',
        headers: {
          [TokenKey]: getToken(),
          'content-type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify(params),
        url: `${process.env.VUE_APP_BASE_API}/health-emr/checklist/sendChecklistMessage`
      }).then((res = {}) => {
        const { data = {} } = res
        const { code, msg } = data
        if (code === 0) {
          Message.success('发送成功')
          return
        }
        Message.error(msg)
      })
    }
  })
}
// 图片上传成功后的回调
const onSuccess = list => {
  fileList.value = list.map(it => {
    return {
      filePath: it.path,
      fileName: it.name
    }
  })
}
const loading = ref(false)
// 提交检查单图片
const handleOk = () => {
  loading.value = true
  const query = {
    ucPatientId,
    ucDoctorId,
    ucPatientName,
    urlList: fileList.value,
    groupId: props.chatId,
    source: 1
  }
  uploadCheckFile(query).finally(() => {
    loading.value = false
    fileList.value = []
    visible.value = false
  })
}
const handleCancel = () => {
  fileList.value = []
  visible.value = false
}
</script>
<style lang="scss" scoped>
@import '../../index.scss';
.remind_way {
  p {
    font-weight: 400;
    font-size: 14px;
    color: #595959;
    padding-right: 20px;
    margin-bottom: 10px;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.modal_title {
  display: flex;
  align-items: center;
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #000000d9;
  }
  .tips {
    font-weight: 400;
    font-size: 12px;
    color: #ffa940;
  }
}
</style>
